import { Grid, makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { LineChart } from "../../../../components/charts/LineChart";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";
import { suspiciousConsumptionData } from "../sample";
import MoonIcon from "../../../../assets/images/dashboard/moon.png";
import SunIcon from "../../../../assets/images/dashboard/sun.png";
import { Icon } from "../../../../components/base/Icon";
import { ColorCircleIndicator } from "../ColorCircleIndicator";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(3.5),
  },
}));

export const SuspiciousUsage = ({ building, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Header
        title="Suspicious usage in premises  "
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#FFE6E6">
        <Typography variant="h4">
          Abnormal high consumption during night time & weekends
        </Typography>
      </InfoBox>

      <Typography className={classes.chartTitle}>
        Consumption over 2021
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={7}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            style={{ paddingLeft: 35 }}
          >
            <Icon src={MoonIcon} />
            <Icon src={SunIcon} />
            <Icon src={MoonIcon} />
          </Grid>
          <LineChart chartData={suspiciousConsumptionData} height={120} />
        </Grid>
        <Grid item xs={5}>
          <Grid container justifyContent="space-between">
            {["M", "T", "W", "T", "F", "S", "S"].map((t, i) => (
              <ColorCircleIndicator key={i} text={t} />
            ))}
          </Grid>
            {Array.from({ length: 4 }).map((_, rowIndex) => (
              <Grid
                key={rowIndex}
                container
                justifyContent="space-between"
              >
                {[null, "L", "L", "L", "H", "H", "H"].map((type, i) => (
                  <ColorCircleIndicator key={i} type={type} />
                ))}
              </Grid>
            ))}
        </Grid>
      </Grid>

      <GroupButton
        buttons={[{ text: "SHARE" }, { text: "EXPORT SAME TYPE ALERTS" }]}
      />
    </Box>
  );
};
